<div class="info-study-container" *ngIf='opened'>

    <div class="card">
        <div class="card-header d-flex align-items-center justify-content-center">
            <h4 style="margin-bottom: 0; margin-left:15%;">Información del estudio</h4>
            <button type="button" style="margin-left: 10%;" class="close" aria-label="Close" (click)="close()">
                <span aria-hidden="true" style="color: #A3ACBF;">&times;</span>
            </button>
        </div>

        <hr class="hr">

        <div class="card-body">
            <div class="options">

                <div class="option">
                    <div class="row_in_line">
                        <span>
                            <span class="text-golden">{{'MENU.INFO_DATA.PATIENT' |
                                translate}}</span>:&nbsp;{{bookStudies[0].patientName}}
                        </span>
                    </div>

                    <div class="row_in_line">
                        <span *ngIf="bookStudies.length==1; else elseDescription">
                            <span class="text-golden">{{'MENU.INFO_DATA.DESCRITPION' |
                                translate}}</span>:&nbsp;{{bookStudies[0].description}}
                        </span>

                        <ng-template #elseDescription>
                            <span style="color: white;">
                                <span class="text-golden">{{'MENU.INFO_DATA.STUDIES' | translate}}</span>:&nbsp;
                            </span>
                            <div class="col-12 less-opacity" style="color: white;">
                                <ul>
                                    <li *ngFor="let s of bookStudies">
                                        <span>{{s.description}}</span> - <span class="text-golden">{{s.studyDate |
                                            date:'dd/MM/yyyy'}}</span>
                                    </li>
                                </ul>
                            </div>
                        </ng-template>

                    </div>
                    <div class="row_in_line">
                        <span>
                            <span class="text-golden">{{'MENU.INFO_DATA.STUDY_DATE' | translate}}</span>
                            :&nbsp;{{bookStudies[0].studyDate | date:'dd/MM/yyyy'}}
                        </span>-
                    </div>
                    <div class="row_in_line">
                        <span>
                            <span class="text-golden">{{'MENU.INFO_DATA.LOCATOR' | translate}}:</span>
                            <span>&nbsp;{{locator}}</span>
                        </span>
                    </div>
                    <div class="row_in_line">
                        <!--<span class="text-golden" style="font-size: 13px;">
                            {{'MENU.INFO_DATA.CADUCITY' | translate}}: {{caducityTime | date:'mediumDate':'UTC':'es'}}
                        </span>-->
                    </div>





                </div>


            </div>
        </div>

    </div>


</div>